import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {I18n, Translate} from 'react-redux-i18n';
import {Button, EntityIllustration, OperaStatus} from 'front-onceforall-core';
import ActionBar from '../../../layout/ActionBar';
import {getOrganisationLogoUrl} from '../../../utils/organisation';
import FavoriteRelationship from '../../favoriteRelationship';
import OrganisationDetails from '../../organisation/OrganisationDetails';
import {useSubcontractorDetailsStore} from '../SubcontractorDetailsStore';
import {ACTRADIS_MASTER_PLATFORM} from '../../../utils/constant';
import {getDistinctCountries} from '../../../utils/document';
import DossierState from '../../dossier/DossierState';
import DossierCountrySelector from '../../dossierCountrySelector';
import RemindButton from '../../remindButton';
import Menu from './menu';
import authenticationService from '../../../services/authentication/AuthenticationService';
import documentService from '../../../services/document/DocumentService';
import {openOrSaveFile} from '../../../utils/http';
import {recordGAEvent} from '../../../utils/analytics';

function HeaderView(props) {
  const [organisation, currentLocale] = useSelector(state => [
    state.organisation,
    state.i18n.locale
  ]);
  const {
    state: {
      subcontractor: {details},
      documents,
      dossierCountry
    },
    dispatch
  } = useSubcontractorDetailsStore();
  const countries = getDistinctCountries(documents.list);

  function handleDownloadDossierOverview() {
    if (details.depositor) {
      recordGAEvent('BUYER_QUITUS', 'Download supplier’s Quitus');
      authenticationService.authRedirect(documentService.downloadDossierOverview(
        details.organisationId,
        currentLocale,
        dossierCountry
      ))
        .then(authUrl => openOrSaveFile(authUrl));
    }
  }

  return (
    <>
      <ActionBar
        showBackButton
        customUrl="/subcontractors"
      >
        <div className="flex-container space-between py-2 w-100">
          <div className="flex-container">
            <EntityIllustration
              country={details.country}
              name={details.fullName}
              imageUrl={getOrganisationLogoUrl(details.organisationId)}
            />
            <div
              data-id="toggleLink"
              className="ml-5 clickable flex-container"
              tooltip={I18n.t(props.areDetailsShown ? 'action.collapseDetails' : 'action.expandDetails')}
              flow="right"
              onClick={props.onSwitchDetails}
            >
              <strong style={{fontSize: '2.5rem'}}>{details.fullName}</strong>
              <span
                className={`ml-3 ${props.areDetailsShown ? 'caret-raise' : 'caret-drop'}`}
                style={{height: 13, width: 13}}
              />
            </div>
            <div className="mx-5 flex-container">
              {!details.enabled &&
                <span className="no-wrap chip">
                  <Translate value="organisation.deactivated.title"/>
                </span>
              }
              <DossierState
                state={props.dossierState}
                onClick={handleDownloadDossierOverview}
              />
            </div>
            <OperaStatus
              organisation={details}
              masterPlatformToShow={ACTRADIS_MASTER_PLATFORM}
            />
          </div>
          <div className="flex-container">
            <div className="mr-4">
              <FavoriteRelationship
                clientId={organisation.organisationId}
                subcontractorId={details.organisationId}
                organisationName={details.fullName}
              />
            </div>
            {countries.length > 1 &&
              <DossierCountrySelector
                countries={countries}
                onChange={event => dispatch({type: 'UPDATE_DOSSIER_COUNTRY', dossierCountry: event.target.value})}
                value={dossierCountry}
              />
            }
            <div className="flex-container ml-4">
              {details.depositor ?
                <RemindButton
                  organisation={details}
                  country={dossierCountry}
                  primaryAction
                /> :
                <Button
                  type="cta"
                  size="large"
                  icon="redo"
                  onClick={props.onReinvite}
                >
                  {I18n.t('subcontractor.reinvite.action')}
                </Button>
              }
              <Menu onDownloadDossierOverview={handleDownloadDossierOverview}/>
            </div>
          </div>
        </div>
      </ActionBar>
      <OrganisationDetails
        organisation={details}
        isExpanded={props.areDetailsShown}
      />
    </>
  );
}

HeaderView.propTypes = {
  dossierState: PropTypes.string,
  areDetailsShown: PropTypes.bool,
  onSwitchDetails: PropTypes.func.isRequired,
  onReinvite: PropTypes.func.isRequired
};

export default HeaderView;
